import React from 'react';
export function Footer() {
  return <footer className="bg-white/50 border-t border-brand-border py-8 px-4 text-center" data-id="element-151">
      <div className="max-w-4xl mx-auto" data-id="element-152">
        <div className="font-body text-xs text-brand-textMuted tracking-wide" data-id="element-153">
          © El Manual del Instructor de Zumba 2025
        </div>
      </div>
    </footer>;
}